export default __webpack_public_path__ + "static/media/heart-filled.30537650.svg";